import restClientService from "../RestClientService";
import { utils } from "../shopifyInjector/utils";
import CommonConstants from "../CommonConstants";
import cartonomyConfig from "../../bootstrap/cartonomy_config";

export const retailerService = {
    async getRetailer(){
        let localRetailer = window.localStorage.getItem(CommonConstants.SessionStorage.RETAILER_DATA);
        if(!localRetailer){
            let _retailer = await this.checkRetailer();
            window.localStorage.setItem(CommonConstants.SessionStorage.RETAILER_DATA,_retailer ? JSON.stringify(_retailer) : _retailer);
            return _retailer;
        }
        return await JSON.parse(localRetailer);
    },

  async getTranslations() {
    return await restClientService.get(`${cartonomyConfig.backendEndPoint}/api/locales?shop=${utils.retailerShop}`);
  },

  async getLogo() {
    return await restClientService.get(`${cartonomyConfig.backendEndPoint}/api/styles/logo?shop=${utils.retailerShop}`);
  },

  async updateRetailer() {
    let _retailer = await restClientService.get(`${utils.cartonomyApiUrl}v2/retailer/default?shop=${utils.retailerShop}`);
    window.localStorage.setItem(CommonConstants.SessionStorage.RETAILER_DATA,_retailer ? JSON.stringify(_retailer) : _retailer);
  },

    checkRetailer() {
        return restClientService.get(`${utils.cartonomyApiUrl}v2/retailer/default?shop=${utils.retailerShop}`);
    },

    async setRetailerCurrencyFormat(retailerId, moneyFormat) {
        return restClientService.post(`${utils.cartonomyApiUrl}v2/retailer/${retailerId}/setting/currency`, {
            MoneyFormat: moneyFormat
        });
    }
};



// WEBPACK FOOTER //
// ./src/utils/helpers/retailerService.js